module.exports = __webpack_public_path__ + "img/9788971968505.29a0eca3.jpg";